
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "m62 44.5c0 12-10.9 17.5-29.8 17.5-19 0-29.8-5.5-29.8-17.5 0-17.6 59.6-17.6 59.6 0", fill: "#e7a74f" }),
	React.createElement("path", { d: "m61.8 36.2c0 12-10.8 17.5-29.7 17.5-18.8 0-29.7-5.5-29.7-17.5.1-17.5 59.4-17.5 59.4 0", fill: "#ba8443" }),
	React.createElement("path", { d: "m2.4 36.5c0-5 5.9-11.9 29.8-11.9s29.8 7 29.8 11.9c0 9.1-8.4 15.7-29.8 15.7-21.4 0-29.8-6.6-29.8-15.7", fill: "#826046" }),
	React.createElement("path", { d: "M3,31.3c0-5,5.8-11.9,29.2-11.9c23.4,0,29.2,7,29.2,11.9c0,9.1-8.2,15.7-29.2,15.7S3,40.4,3,31.3z", fill: "#68472c" }),
	React.createElement("path", { d: "m3.2 24.8c1.4-3 5.1-3.2 17.1 1.9 12 5.1 14.3 7.8 12.9 10.9-2.6 5.5-9.7 9.6-20.5 5s-12.2-12.2-9.5-17.8", fill: "#ef4d3c" }),
	React.createElement("path", { d: "m4.2 21.4c1.4-3 5.1-3.2 17.1 1.9 12 5.1 14.3 7.8 12.9 10.9-2.6 5.5-9.7 9.6-20.5 5-10.8-4.6-12.2-12.3-9.5-17.8", fill: "#d33b23" }),
	React.createElement("path", { d: "m29.3 34.5c-.8-3.2 2-5.5 14.9-8.3s16.4-2 17.2 1.3c1.5 5.9-1.5 13.2-13.1 15.7-11.5 2.5-17.6-2.8-19-8.7", fill: "#ef4d3c" }),
	React.createElement("path", { d: "m28 31.3c-.8-3.2 2-5.5 14.9-8.3 12.9-2.8 16.4-2 17.2 1.3 1.5 5.9-1.5 13.2-13.1 15.7-11.5 2.5-17.5-2.8-19-8.7", fill: "#d33b23" }),
	React.createElement("path", { d: "m9.7 30.9l20 19.2 19.6-19.2z", fill: "#ffe62e" }),
	React.createElement("path", { d: "m60.7 25.9c0 0 .9 3.4 0 4.4-.8.9-3.3-.1-4.4.7-1 .7-.7 3.4-1.9 4-1.1.6-3.2-1.1-4.4-.6-1.1.4-1.5 3.1-2.7 3.5-1.2.3-3-1.7-4.2-1.5-1.2.2-2 2.8-3.3 3-1.2.2-2.7-2.1-4-2-1.2.1-2.4 2.5-3.7 2.5-1.3 0-2.4-2.5-3.7-2.5-1.3-.1-2.7 2.2-4 2-1.3-.2-2.1-2.7-3.3-3-1.3-.3-3 1.8-4.2 1.5-1.2-.4-1.6-3-2.7-3.5-1.2-.5-3.4 1.2-4.4.6-1.2-.6-.9-3.3-1.9-4-1.1-.8-3.6.2-4.4-.7-.9-1 0-4.4 0-4.4h57.2", fill: "#8cc63e" }),
	React.createElement("path", { d: "M62,23.4c0,6.5-13.3,9.7-29.8,9.7c-16.5,0-29.8-3.2-29.8-9.7C2.4,11.6,15.7,2,32.2,2C48.7,2,62,11.6,62,23.4z ", fill: "#e7a74f" }),
	React.createElement(
		"g",
		{ fill: "#ffc17a" },
		React.createElement("path", { d: "m16.3 14.4l-1.6 1.5-1.5-1.5 1.5-1.5z" }),
		React.createElement("path", { d: "m23.7 12l-1.5 1.5-1.5-1.5 1.5-1.5z" }),
		React.createElement("path", { d: "m28 18.8l-1.6 1.5-1.5-1.5 1.5-1.5z" }),
		React.createElement("path", { d: "m33.2 13.4l-1 1-1-1 1-1z" }),
		React.createElement("path", { d: "m51.9 17.3l-1 1-1-1 1-1z" }),
		React.createElement("path", { d: "m58.1 18.3l-1 1-1-1 1-1z" }),
		React.createElement("path", { d: "m46.4 11l-1 1-1-1 1-1z" }),
		React.createElement("path", { d: "m15.9 9.7l-1 1-1-1 1-1z" }),
		React.createElement("path", { d: "m10.5 14.4l-1 1-1-1 1-1z" }),
		React.createElement("path", { d: "m16.8 21.1l-1 1-1.1-1 1.1-1z" }),
		React.createElement("path", { d: "m28.5 5.7l-1 1-1.1-1 1.1-1z" }),
		React.createElement("path", { d: "m38 4.7l-1 1-1-1 1-1z" }),
		React.createElement("path", { d: "m22.2 6.7l-1 1-1-1 1-1z" }),
		React.createElement("path", { d: "m50.9 9.1l-1 1-1-1 1-1z" }),
		React.createElement("path", { d: "m40 21.7l-1.5 1.5-1.5-1.5 1.5-1.5z" }),
		React.createElement("path", { d: "m37.6 14l-1.5 1.5-1.5-1.5 1.5-1.5z" }),
		React.createElement("path", { d: "m43.2 8.2l-1.5 1.5-1.5-1.5 1.5-1.5z" }),
		React.createElement("path", { d: "m47.6 14.7l-1.5 1.5-1.6-1.5 1.6-1.5z" }),
		React.createElement("path", { d: "m54 12.5l-1.5 1.5-1.6-1.5 1.6-1.5z" }),
		React.createElement("path", { d: "m49.1 21.3l-1.5 1.5-1.5-1.5 1.5-1.5z" }),
		React.createElement("path", { d: "m12.5 18.7l-1.5 1.5-1.5-1.5 1.5-1.5z" })
	)
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/hamburger.js
// module id = 700
// module chunks = 0